import { LazyAction, LazyModule } from 'owa-bundling-light';
import type * as lazyIndex from './lazyIndex';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "HeaderMicrosoft365UpsellClick" */ './lazyIndex'),
    { name: 'HeaderMicrosoft365UpsellClick' }
);

export const lazyOnMicrosoft365UpsellButtonClicked: LazyAction<
    typeof lazyIndex.onMicrosoft365UpsellButtonClicked,
    typeof lazyModule
> = new LazyAction(lazyModule, module => module.onMicrosoft365UpsellButtonClicked);
